module.exports = __webpack_public_path__ + "img/peradi-v2.1af6896e.png";